import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { delay: { type: Number, default: 3000 } };

  connect() {
    this.element.loop = false; // a looping <video> never fires `ended`, so the listener would be dead
    this.element.addEventListener('ended', this.__handleEnded);
  }

  disconnect() {
    clearTimeout(this.__timer);
    this.element.removeEventListener('ended', this.__handleEnded);
    this.__rester.classList.remove('is-resting');
  }

  // The wrapper (when present) is what CSS dims during the rest; falls back to the video itself.
  get __rester() {
    return this.element.closest('.screencap-video') ?? this.element;
  }

  __handleEnded = () => {
    this.__rester.classList.add('is-resting');
    this.__timer = setTimeout(() => {
      this.element.currentTime = 0;
      this.element.play().catch((error) => console.warn('Video autoplay failed:', error)); // eslint-disable-line no-console
      this.__rester.classList.remove('is-resting'); // fade back in over the frame-1 seek, hiding the snap
    }, this.delayValue);
  };
}
